import { render, staticRenderFns } from "./BusinessDetailsStep.vue?vue&type=template&id=209dba13&scoped=true&"
import script from "./BusinessDetailsStep.vue?vue&type=script&lang=ts&"
export * from "./BusinessDetailsStep.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessDetailsStep.vue?vue&type=style&index=0&id=209dba13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209dba13",
  null
  
)

export default component.exports